import * as React from 'react'
import PropTypes from 'prop-types'
import AvisosMarino from './AvisosMarino'
import PronosMarinoDialog from './PronosMarionoDialog'

function AvisosMarinoDialog({ dataAvisos, open, pathPrefixLogo, handleClose }) {
    return (
        <PronosMarinoDialog
            open={open}
            pathPrefixLogo={pathPrefixLogo}
            handleClose={handleClose}
            exportToPdf
            dialogContent={<AvisosMarino dataAvisos={dataAvisos} />}
        />
    )
}

export default AvisosMarinoDialog

AvisosMarinoDialog.propTypes = {
    dataAvisos: PropTypes.object,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    pathPrefixLogo: PropTypes.string,
}
